import React from 'react';
import { normalizeProductTypeForTracking } from '@helpers/utils/catalog/catalog-tracking-utils';
import CatalogProductFeed from '@components/catalog/catalog-product-feed/catalog-product-feed';
import { CatalogProduct } from '@interfaces/models/catalogProduct';
import { Product } from '@interfaces/models/product';

type CatalogListProps = {
  containerClsx?: React.CSSProperties | string;
  productType?: string;
  // When set (e.g. from CMS display title), overrides productType-based category for tracking
  productFeedCategory?: string;
  // Fraction of the card visible (0–1) before useOnReveal counts a product impression; CMS custom landing passes 0.25 instead of the default 1 (full visibility).
  impressionRevealThreshold?: number;
  isLoading: boolean;
  products: Array<Product | CatalogProduct>;
  // CMS context for cms_content_click tracking
  cmsProps?: {
    sectionIdx?: string;
    contentTypeUid?: string;
    blockUid?: string;
    productType?: string;
    productFeedIndex?: string;
  };
};

const CatalogList: React.FC<CatalogListProps> = (props): React.JSX.Element => {
  const { containerClsx, productType, productFeedCategory, impressionRevealThreshold, products, isLoading, cmsProps } =
    props;

  return (
    <CatalogProductFeed
      {...{ products, containerClsx, isLoading }}
      impressionRevealThreshold={impressionRevealThreshold}
      productCardProps={{
        pageType: 'cms_page',
        moduleType: productType,
        productFeedCategory: productFeedCategory ?? normalizeProductTypeForTracking(productType),
        parentPosition: cmsProps?.sectionIdx,
        cmsProps,
      }}
    />
  );
};

export default CatalogList;
